import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../_services/auth/auth.service';
import {first} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {BASE_URL} from '../../../_services/constants';
import {loginItem, loginItemList} from '../../../_animations/loginAnimations';

interface LoginForm {
  email: string;
  password: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss', '../../../../loginForm.scss'],
  animations: [loginItemList, loginItem]
})
export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChild('usernameinput') private inputElement: ElementRef;

  form: FormGroup;
  returnUrl: string;

  message: string;
  messageType: string;
  loading: boolean;

  emailAutofiller: string;
  passwordAutofiller: string;

  constructor(private formBuilder: FormBuilder, private authService: AuthService, private router: Router, private route: ActivatedRoute) {
    this.emailAutofiller = '';
    this.passwordAutofiller = '';
    if (this.router.getCurrentNavigation().extras.state) {
      if (this.router.getCurrentNavigation().extras.state.mode === 'reset_email') {
        this.message = 'We\'ve emailed you instructions for setting your password.';
        this.messageType = 'success';
      } else if (this.router.getCurrentNavigation().extras.state.mode === 'inactive_link') {
        this.message = 'Link is inactive';
        this.messageType = 'danger';
      }
    }
  }

  ngOnInit(): void {
    this.loading = false;
    this.authService.logout();
    this.form = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    this.route.queryParams.subscribe((params) => {
      if (params.l) {
        try {
          const obj = JSON.parse(atob(params.l));
          setTimeout(() => {this.type(obj.username, obj.password, 0); }, 450);
        } catch (error) {
          this.router.navigate(['/login'], {
            queryParams: {
              l: null
            },
            queryParamsHandling: 'merge'
          });
        }

      }
    });
  }

  ngAfterViewInit(): void {
    this.inputElement.nativeElement.focus();
  }

  // TODO autocomplete on first login
  type(email, password, iterator, current= 'email') {
    let len = 0;
    const timing = 50;
    if (current === 'email') {
      if (iterator === 0) {
        this.emailAutofiller = '';
      }
      this.emailAutofiller += email.charAt(iterator);
      this.form.controls.username.setValue(this.emailAutofiller);

      len = email.length;
    } else {
      if (iterator === 0) {
        this.passwordAutofiller  = '';
      }
      this.passwordAutofiller += password.charAt(iterator);
      len = password.length;
      this.form.controls.password.setValue(this.passwordAutofiller);
    }
    const n_i = iterator + 1;
    if (n_i < len + 1) {
      setTimeout(() => {this.type(email, password, n_i, current); }, timing);
    } else if (current === 'email') {
      setTimeout(() => {this.type(email, password, 0, 'password'); }, timing);
    } else if (current === 'password') {
      this.onLogin();
    }
  }

  onLogin() {
    this.message = '';
    this.loading = true;
    this.authService.loginUser(this.form.value).pipe(first()).subscribe(
      response => {
        // this.router.navigate(['/'], {
        //   queryParams: {
        //     l: null
        //   },
        //   queryParamsHandling: 'merge'
        // });

        this.router.navigateByUrl(this.returnUrl);
        this.loading = false;
        this.message = response.message;
        this.messageType = response.type;
      },
      error => {
        this.router.navigate(['/login'], {
          queryParams: {
            l: null
          },
          queryParamsHandling: 'merge'
        });
        this.loading = false;
        this.message = error.statusText;
        this.messageType = 'danger';
      }
    );
  }

  loginWithMicrosoft() {
    this.loading = true;
    // window.location.href = BASE_URL + '/social/login/azuread-oauth2/';
    window.location.href = BASE_URL + '/social/login/azuread-b2c-oauth2/';
  }
}


